import en from './en';
import bg from './bg';
import de from './de';

export default {
	en: en,
	bg: bg,
	de: de,
}